import React from 'react'
import Link from 'gatsby-link'

//  Styles
// import styles from './StateRankingTable.module.scss'

const StateHighlights = ( { state } ) => {
  const stateData = require('../../data/highlights/' + state + '.json')
  return (
    <div>
      <h2 className="section__title__secondary">Highlights</h2>
      <div className="section__row section__row__2_up">
        <div className="section__content">
          <h3 className="section__subtitle">Top Ranked Indicators</h3>
          <ul>
            <li className="improved">{ stateData.top3[0] }</li>
            <li className="improved">{ stateData.top3[1] }</li>
            <li className="improved">{ stateData.top3[2] }</li>
          </ul>
          <h3 className="section__subtitle">Bottom Ranked Indicators</h3>
          <ul>
            <li className="worsened">{ stateData.bottom3[0] }</li>
            <li className="worsened">{ stateData.bottom3[1] }</li>
            <li className="worsened">{ stateData.bottom3[2] }</li>
          </ul>
        </div>
        <div className="section__content">
          <h3 className="section__subtitle">Most Improved Indicators</h3>
          <ul>
            <li className="improved">{ stateData.most_improved[0] }</li>
            <li className="improved">{ stateData.most_improved[1] }</li>
            <li className="improved">{ stateData.most_improved[2] }</li>
          </ul>
          <h3 className="section__subtitle">Indicators That Worsened the Most</h3>
          <ul>
            <li className="worsened">{ stateData.most_declined[0] }</li>
            <li className="worsened">{ stateData.most_declined[1] }</li>
            <li className="worsened">{ stateData.most_declined[2] }</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default StateHighlights



// WEBPACK FOOTER //
// ./src/components/StateHighlights/StateHighlights.js